export default class RulesListController {

}



// WEBPACK FOOTER //
// ./app/common/rules-list/rules.controller.js